<template>
  <div class="dialog-item-edit">
    <menu-title :close="close">{{ target.menuName }}</menu-title>
    <menu-item label="弹窗背景">
      <menu-fill :target="target.background" />
      <menu-background-image :target="target.background" class="mt-2" />
    </menu-item>
    <menu-item label="弹窗圆角">
      <menu-slider v-model="target.radius" />
    </menu-item>
    <menu-item label="布局">
      <menu-switch v-model="target.titleVisible" label="标题" />
      <menu-switch v-model="target.describeVisible" label="描述" />
      <menu-switch v-model="target.buttonVisible" label="是否显示按钮">
        <base-input v-model="target.buttonName" class="w-full mt-2" size="small" placeholder="按钮名称" />
      </menu-switch>
      <menu-switch v-model="target.immediate" label="是否开屏显示">
        <im-select v-if="target.immediate" v-model="target.showType" :options="DialogShowTypeEnums" class="w-full mt-2" size="small" placeholder="请选择" />
      </menu-switch>
    </menu-item>
    <menu-item label="弹窗分屏">
      <div v-for="(item, index) in target.children" :key="item.id" class="screen-item">
        <div class="screen-header">
          <span class="header-title">第{{ index + 1 }}屏</span>
          <i v-if="index !== 0" class="delete-btn el-icon-delete" @click="handleRemoveChild(index)" />
        </div>
        <div v-for="(child, indexChild) in item.list" :key="child.id" class="block-item">
          <div class="flex items-center justify-between">
            <span>板块{{ indexChild + 1 }}</span>
            <i v-if="indexChild !== 0" class="delete-btn el-icon-delete" @click="item.list.splice(indexChild, 1)" />
          </div>
          <menu-background-image class="mt-2" :target="child.background" :event-key="`show-dialog-collection-img-${index}-${indexChild}`" />
        </div>
        <menu-button v-if="item.list.length < 3" class="mt-2" icon="add" @click.native="handleAddBlock(index)">添加板块{{item.list.length}}/3</menu-button>
        <nav-edit class="mt-2" :target="item" :site="site" :filter-modules="[WidgetModelNames.DialogCollectionWidgetModel]" />
      </div>
    </menu-item>
    <menu-button v-if="target.children.length < 5" class="mt-4" icon="add" @click.native="handleAddItem">添加弹窗分屏</menu-button>
    <delete-block-trigger class="mt-4" title="删除弹窗" :is-delete-block="false" @delete-block="onDelete" />
  </div>
</template>

<script>
import menuTitle from '~/components/menu/menuTitle.vue'
import deleteBlockTrigger from '~/site/components/editMenu/deleteBlockTrigger.vue'
import MenuItem from "~/components/menu/menuItem.vue"
import MenuFill from "~/components/menu/menuFill.vue"
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue"
import MenuSlider from "~/components/menu/menuSlider.vue"
import MenuSwitch from "~/components/menu/menuSwitch.vue"
import BaseInput from "~/components/base/baseInput.vue"
import ImSelect from "~/components/common/ImSelect.vue"
import { DialogShowTypeEnums, WidgetModelNames } from '~/enums/siteEnum'
import MenuButton from '~/components/menu/menuButton.vue'
import NavEdit from '~/site/components/navEdit.vue'

export default {
  components: {
    NavEdit,
    MenuButton,
    ImSelect,
    BaseInput,
    MenuSwitch,
    MenuSlider,
    MenuBackgroundImage,
    MenuFill,
    MenuItem,
    deleteBlockTrigger,
    menuTitle
  },
  props: {
    childIndex: Number,
    target: Object,
    model: Object,
    site: Object
  },
  data() {
    return {
      DialogShowTypeEnums,
      WidgetModelNames
    }
  },
  methods: {
    close() {
      this.SiteMenu.close()
    },
    handleAddItem() {
      this.target.__addItem()
      this.$nextTick(() => {
        this.model?.__refresh()
      })
    },
    handleAddBlock(index) {
      this.target.__addListItem(index)
      this.$nextTick(() => {
        this.model?.__refreshRichText()
      })
    },
    handleRemoveChild(index) {
      this.target.children.splice(index, 1)
      this.$nextTick(() => {
        this.model?.__refresh()
      })
    },
    onDelete() {
      this.close()
      this.$store.commit('site/SET_CURRENT_VISIBLE_DIALOG_ID', null)
      const index = this.model.children.findIndex(child => child.id === this.target.id)
      if (index > -1) {
        this.model.children.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.screen-item {
  background: var(--bg-color-base);
  border: 1px solid var(--bg-color-hover);
  border-radius: 8px;
  padding: 16px 6px;
  margin-bottom: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: var(--bg-color-hover);
    border-color: var(--text-color-alpha-3);
    box-shadow: var(--shadow-lg);
  }

  .screen-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--border-color-base);

    .header-title {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-color);
      letter-spacing: 0.5px;
    }
  }

  .block-item {
    background: var(--bg-color-base);
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid transparent;
    transition: all 0.2s;

    &:hover {
      background: var(--bg-color-hover);
      border-color: var(--text-color-alpha-3);
    }

    .block-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;

      .block-title {
        font-size: 12px;
        color: var(--text-color-alpha-9);
        font-weight: 500;
      }
    }
  }

  .delete-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    color: var(--text-color-alpha-4);
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: var(--opacity-error-color);
      color: var(--danger-color);
    }

    i {
      font-size: 14px;
    }
  }
}
</style>
